<template>
  <div class="garden-help-login garden-help-auth-container garden-help-auth-bg-container">
    <div class="h-100">
      <div class="row h-100 m-0 authRowContainer">
        <div class="col-xl-4 col-lg-6 col-md-9 col-sm-12 mx-auto my-auto">
          <Login
            titleH2=""
            welcomeHeader="Welcome to GardenHelp!"
            welcomeSubheader="Please sign-in to your account to choose from our Extensive Range of Professional Landscaping Services"
            logoSrc="garden-help/Logo.png"
            guard="GARDENHELP"
            clientLink="garden_help"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Login from "@/components/auth/Login";

export default {
  name: "GardenHelpLogin",
  components: { Login },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onSubmit() {
      console.log("submit login");
    },
  },
};
</script>
<style  scoped::v-deep>
@import "../styles/garden-help-auth-styles.css";
</style>



// WEBPACK FOOTER //
// src/projects/garden_help/auth/LoginView.vue